// extracted by mini-css-extract-plugin
export default {"root":"ConfigurationView_root__3X9bL","input":"ConfigurationView_input__1jXz8"};